import type { FC } from 'react';
import { useState } from 'react';
import type { DirectDebitStatus } from '@pflegenavi/shared/api';
import type { UseMutationResult } from '@tanstack/react-query';
import { CancelDirectDebitMangopayModal } from './CancelDirectDebitMangopayModal';
import { CancelDirectDebitMangopayView } from './CancelDirectDebitMangopayView';

interface CancelDirectDebitProps {
  status: DirectDebitStatus;
  useDeleteDirectDebitMandate: () => UseMutationResult<
    void,
    unknown,
    {
      paymentProcessorMode: 'live' | 'test';
      resident_id: string;
      tenant: string;
    }
  >;
  onCancelClick?: () => void;
  isFamilyMember?: boolean;
  isDisabled?: boolean;
}

export const CancelDirectDebitMangopay: FC<CancelDirectDebitProps> = ({
  status,
  useDeleteDirectDebitMandate,
  onCancelClick,
  isFamilyMember = false,
  isDisabled = false,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const handleModalOpen = () => {
    if (onCancelClick) {
      onCancelClick();
    }
    setOpenModal(true);
  };
  const handleModalClose = () => setOpenModal(false);

  return (
    <>
      <CancelDirectDebitMangopayView
        status={status}
        onCancelClick={handleModalOpen}
        isDisabled={isDisabled}
      />
      <CancelDirectDebitMangopayModal
        open={openModal}
        handleClose={handleModalClose}
        useDeleteDirectDebitMandate={useDeleteDirectDebitMandate}
        isFamilyMember={isFamilyMember}
      />
    </>
  );
};
